<template>
  <component :is="$route.meta.layout" />
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'
import AppLayout from '@/layouts/AppLayout.vue'
import SimpleLayout from '@/layouts/SimpleLayout.vue'
import PrintLayout from '@/layouts/PrintLayout.vue'
import CSEditorLayout from '@/layouts/CSEditorLayout.vue'

function hexToRgb(hex) {
  const h = hex.replace('#', '')
  return [parseInt(h.substring(0, 2), 16), parseInt(h.substring(2, 4), 16), parseInt(h.substring(4, 6), 16)].join(', ')
}

export default {
  name: 'App',

  metaInfo() {
    const brand =
      this.$store.getters['whitelabel/is_whitelabel'] && this.$store.getters['whitelabel/name']
        ? this.$store.getters['whitelabel/name']
        : 'Flaminjoy'
    return {
      title: 'Dashboard',
      titleTemplate: `%s | ${brand}`,
    }
  },

  components: {
    'app-layout': AppLayout,
    'auth-layout': AuthLayout,
    'simple-layout': SimpleLayout,
    'print-layout': PrintLayout,
    'cs-editor-layout': CSEditorLayout,
  },

  mounted() {
    this.applyWhitelabelColors()
    this.applyWhitelabelFavicon()
  },

  methods: {
    applyWhitelabelColors() {
      const isWhitelabel = this.$store.getters['whitelabel/is_whitelabel']
      if (!isWhitelabel) return

      const root = document.documentElement
      const primary = this.$store.getters['whitelabel/primary_color']
      const secondary = this.$store.getters['whitelabel/secondary_color']

      if (primary) {
        root.style.setProperty('--wl-primary-color', primary)
        root.style.setProperty('--wl-primary-color-rgb', hexToRgb(primary))
      }
      if (secondary) {
        root.style.setProperty('--wl-secondary-color', secondary)
      }

      const headerColor = this.$store.getters['whitelabel/header_color']
      if (headerColor) {
        root.style.setProperty('--wl-header-color', headerColor)
      }
    },

    applyWhitelabelFavicon() {
      const favicon = this.$store.getters['whitelabel/favicon']
      if (!favicon) return

      let link = document.querySelector('link[rel="icon"]')
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
      }
      link.href = favicon
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/sass/style.scss';
</style>
